import React from "react";
import { get } from "lodash";
import { Action } from "@sonder/ui/source/styled/components/Action";
import { ActionContent } from "@sonder/ui/source/styled/components/ActionContent";
import { PrimaryButton } from "@sonder/ui/source/styled/fragments/PrimaryButton";
import { useSegment } from "analytics/segment";
import { useStore as useAuthStore } from "auth/store";
import { useErrorReporterFiltered } from "core/hooks/useErrorReporterFiltered";
import { TaskAction as TaskActionTypes } from "core/queries/GetTaskComments";
import { useUpdateTask } from "core/queries/UpdateTask";

interface TaskActionInterface {
  action: TaskActionTypes;
  loggedInUserId: string;
  taskId: string;
}

export const TaskAction = ({
  action,
  loggedInUserId,
  taskId,
}: TaskActionInterface) => {
  const errorReporter = useErrorReporterFiltered();
  const { track } = useSegment();
  const { state: authState } = useAuthStore();
  const [onUpdateTask, { loading: isUpdating }] = useUpdateTask({
    refetchQueries: ["GetTaskComments"],
    awaitRefetchQueries: true,
  });
  const isGETMember = get(authState, "user.isGETMember", false);
  const completeCopy = isUpdating ? "Undoing..." : "Undo";
  const incompleteCopy = isUpdating ? "Doing..." : "Done";
  const isCompleted = action.status === "complete";
  const onHandleComplete = async () => {
    try {
      const actionId = action.id;
      const nextStatus = action.status === "complete" ? "ready" : "complete";
      await onUpdateTask({
        variables: { taskId: actionId, status: nextStatus },
      });
      track({
        eventName: "task_panel",
        action: "click",
        element: "add_action_complete",
        props: {
          taskId,
          actionId,
          nextValue: nextStatus,
        },
      });
    } catch (e) {
      errorReporter.notify(e);
    }
  };
  return (
    <Action
      authorId={get(action, "author.id", "")}
      authorName={get(action, "author.name", "(Unknown)")}
      createdAt={action.createdAt}
      loggedInUserId={loggedInUserId}
    >
      {action.notes && <div>{action.notes}</div>}
      <ActionContent
        body={action.body}
        completedAt={isCompleted ? action.completedAt : null}
        cta={
          isGETMember && (
            <PrimaryButton disabled={isUpdating} onClick={onHandleComplete}>
              {isCompleted ? completeCopy : incompleteCopy}
            </PrimaryButton>
          )
        }
      />
    </Action>
  );
};
